<template>
  <b-col xs="12" sm="12" md="3" class="py-2 prod-card" v-if="selectedProductDetails != undefined">
    <b-row>
      <b-col class="text-center" md="12" cols="12">
        <div class="prod-card-img-wrapper" @mouseover="handleHover" @mouseleave="hovering = false">
          <a href="#" v-b-modal="'quick-view-modal' + prodDetails.id">
            <img
              :src="getImageUrl(selectedProductDetails.Image)"
              alt
              class="card-image"
              :class="{ 'obscure-card-image': hovering }"
            />
          </a>
          <button
            v-if="hovering"
            v-b-modal="'quick-view-modal' + prodDetails.id"
            class="btn btn-primary hover-preview-btn"
          >
            <font-awesome-icon icon="search"></font-awesome-icon>
          </button>
          <QuickViewModal
            :prod="prodDetails"
            :modalId="'quick-view-modal' + prodDetails.id"
            :prodId="prodDetails.Item_id"
            :currentProd="selectedProductDetails.Item_id"
            :key="selectedProductDetails.Item_id"
          />
        </div>
      </b-col>
      <b-col class="py-2 prod-card-info text-center text-md-left" md="12" cols="12">
        <ul>
          <li>
            <b-row>
              <b-col
                sm="12"
                md="12"
                lg="12"
                style="text-transform:uppercase;font-size:14px;text-align:center;"
              >
                <a href="#" v-b-modal="'quick-view-modal' + prodDetails.id">
                  {{ selectedProductDetails.Title }}
                  <span
                    v-if="(prodDetails.sizes && prodDetails.sizes.length > 1) || selectedProductDetails.Size"
                  >, {{selectedProductDetails.Size}}</span>
                  <span
                    v-if="isUoMNumber(selectedProductDetails.UoM)"
                  >, {{selectedProductDetails.UoM}}</span>
                </a>
              </b-col>

              <b-col
                sm="12"
                md="12"
                lg="12"
                class="font-weight-bold"
                style="color:red;text-align:center;"
              >AED {{ this.getProdPrice(selectedProductDetails.Price) }}</b-col>
            </b-row>
          </li>

          <li class="text-center" v-if="prodDetails.colors">
            <color-component
              v-for="(color, index) in filteredColors"
              :key="index"
              :item="color"
              v-on:item-clicked="changeProduct"
              :active="color == selectedProductDetails"
            ></color-component>
          </li>
          <li class="text-center" v-if="prodDetails.sizes && prodDetails.sizes.length > 1">
            <size-component
              v-for="(size, index) in prodDetails.sizes"
              class="mr-2"
              :item="size"
              v-on:item-clicked="changeProduct"
              :id="id"
              :key="index"
            ></size-component>
          </li>
          <li>
            <h6 class="title text-center"></h6>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import QuickViewModal from "../common-components/QuickViewModal";
import ColorComponent from "./ColorComponent";
import SizeComponent from "./SizeComponent";

export default {
  name: "ProductCard",
  props: ["prodDetails", "filter"],
  components: {
    QuickViewModal,
    ColorComponent,
    SizeComponent,
  },
  watch: {
    fiilter: function () {},
  },
  computed: {
    id() {
      return this.selectedProduct;
    },
    filteredColors() {
      if (this.filter != undefined && this.filter.length > 0) {
        let ProdColors = [];

        this.prodDetails.colors.forEach((product) => {
          let productColor = product.Colour.split("/");

          for (const color of productColor) {
            if (color != "" && this.filter.includes(color)) {
              ProdColors.push(product);
            }
          }
        });
        return ProdColors;
      }
      return this.prodDetails.colors;
    },
    screenIsSmall() {
      if (this.$mq == "lg" || this.$mq == "xl") {
        return false;
      }
      return true;
    },
    selectedProductDetails() {
      if (this.prodDetails.sizes && this.prodDetails.sizes.length > 0) {
        return this.prodDetails.sizes.find(
          (item) => item.Item_id == this.selectedProduct
        );
      }
      if (this.prodDetails.colors && this.prodDetails.colors.length > 0) {
        return this.prodDetails.colors.find(
          (item) => item.Item_id == this.selectedProduct
        );
      }
      return this.prodDetails;
    },
  },
  data() {
    return {
      hovering: false,
      selectedProduct: "",
    };
  },
  methods: {
    changeProduct(item_id) {
      this.selectedProduct = item_id;
    },
    handleHover() {
      if (this.screenIsSmall) {
        return;
      } else {
        this.hovering = true;
      }
    },
  },
  mounted() {
    if (this.prodDetails) {
      this.selectedProduct = this.prodDetails.Item_id;
    }
    if (this.filter.length > 0) {
      this.selectedProduct = this.filteredColors[0].Item_id;
    }
  },
};
</script>

<style>
.card-image {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  object-position: center center;
  border-radius: 5px;
  text-align: center;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.prod-card-img-wrapper {
  max-width: 100%;
  min-height: 200px;
  height: 100%;
  clear: both;
  position: relative;
}

.hover-preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50px;
  background-color: #808080;
  border: none;
  font-size: 20px;
}

.show-preview-btn {
  display: block;
  opacity: 1;
}

.obscure-card-image {
  opacity: 0.4;
}
</style>

<style scoped>
.title {
  overflow: hidden;
  font-style: 14px;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  /* height: 3.2142857143rem; */
  margin-bottom: 0.6rem;
}

a {
  text-decoration: none;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}
</style>
